export default "__VITE_ASSET__DbQNb$qE__"